const Validate = {
  // 邮箱校验
  email: (rule, value, callback) => {
    let regexp = /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入正确格式的邮箱'))
      }
    } else {
      callback()
    }
  },
  // 手机号校验
  mobile: (rule, value, callback) => {
    let regexp = /^1(3|4|5|6|7|8|9)\d{9}$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入正确的手机号'))
      }
    } else {
      callback()
    }
  },
  // 座机校验
  tel: (rule, value, callback) => {
    let regexp = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入正确的电话号'))
      }
    } else {
      callback()
    }
  },
  // 手机加座机
  mobileTel: (rule, value, callback) => {
    let regexp = /^(\+)?(0|86|086|17951)?(-)?[0-9]{11}$/
    let regexp2 = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/
    if (value) {
      if (value.match(regexp) || value.match(regexp2)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入正确的电话号'))
      }
    } else {
      callback()
    }
  },
  // 身份证校验
  identification: (rule, value, callback) => {
    let regexp = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (value) {
      if (value.length !== 18) {
        callback(new Error(rule.message || '身份证号码为18位！'))
      } else if (value.match(regexp)) {
        callback()
      } else {
        callback(
          new Error(rule.message || '身份证必须是数字或者数字与字母组合！')
        )
      }
    } else {
      callback()
    }
  },
  // 传真
  fax: (rule, value, callback) => {
    let regexp = /^(\d{3,4}-)?\d{7,8}$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入正确的传真'))
      }
    } else {
      callback()
    }
  },
  // 邮编
  stamp: (rule, value, callback) => {
    let regexp = /^[0-9]{6}$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else if (value.toString().length > 6) {
        return callback(new Error(`邮编总长度不能大于6`))
      } else {
        callback(new Error(rule.message || '请输入正确格式的邮政编码'))
      }
    } else {
      callback()
    }
  },
  // 中英文姓名
  userName: (rule, value, callback) => {
    let regexp = /^[^0-9]+$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入正确格式的姓名'))
      }
    } else {
      callback()
    }
  },
  // 长度2到5个字符
  userName2: (rule, value, callback) => {
    let regexp = /^\D{2,5}$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '长度在 2 到 5 个字符'))
      }
    } else {
      callback()
    }
  },
  // 纯中文校验
  chinese: (rule, value, callback) => {
    let regexp = /^[\u4e00-\u9fa5]*$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入中文'))
      }
    } else {
      callback()
    }
  },
  // 纯字母校验
  letter: (rule, value, callback) => {
    let regexp = /^[A-Za-z]+$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入字母'))
      }
    } else {
      callback()
    }
  },
  // 大写字母
  uppercase: (rule, value, callback) => {
    let regexp = /^[A-Z]+$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入大写字母'))
      }
    } else {
      callback()
    }
  },
  // 小写字母
  lowercase: (rule, value, callback) => {
    let regexp = /^[a-z]+$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '请输入小写字母'))
      }
    } else {
      callback()
    }
  },
  // 数字和字母
  numAndLetter: (rule, value, callback) => {
    let regexp = /^[0-9a-zA-Z]*$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '只能输入字母和数字！'))
      }
    } else {
      callback()
    }
  },
  // 数字校验
  number: (rule, value, callback) => {
    let regexp = /^[1-9]{1}[0-9]*$/
    let regexp1 = /^[1-9]{1}[0-9]*$|^[+]{0,1}(\d+\.\d+)$/
    if (value) {
      if (rule.dot) {
        if (value.match(regexp1)) {
          callback()
        } else {
          callback(new Error(rule.message || '必须输入正数'))
        }
      } else {
        if (value.match(regexp)) {
          callback()
        } else {
          callback(new Error(rule.message || '必须输入正整数'))
        }
      }
    } else {
      callback()
    }
  },
  // 数字两位小数
  number2: (rule, value, callback) => {
    let regexp = /^[0-9]+([.]{1}[0-9]{1,2})?$/
    if (value) {
      if (value.match(regexp)) {
        callback()
      } else {
        callback(new Error(rule.message || '只能输入数字，精确至两位小数'))
      }
    } else {
      callback()
    }
  },
  minMobile: (rule, value, callback) => {
    let valueSub = value.substr(0, 1)
    if (value) {
      if (isNaN(parseInt(valueSub)) || value.match(/([\u4e00-\u9fa5])|([a-zA-Z])/) || value.match(/[`~!@#$%^&*_\=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*——\={}|《》？：“”【】、；‘’，。、]/)) {
        callback(new Error('请正确输入手机号'))
      }
    }
  },
  char: (rule, value, callback) => {
    if (value) {
      if (value.match(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/)) {
        callback(new Error('请正确输入'))
      }
    }
  }
}

export default Validate
